import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';

import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { QuillModule } from 'ngx-quill';
import { ToastrModule } from 'ngx-toastr';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown'
import { CoreCommonModule } from 'src/@core/common.module';
import {
  CoreSidebarModule,
  CoreThemeCustomizerModule,
} from 'src/@core/components';
import { CoreModule } from 'src/@core/core.module';
import { coreConfig } from './app-config';
import { AppComponent } from './app.component';
import { createTranslateLoader } from './i18n/app-translate.loader';
import { DirectivesModule } from './directives/directives.module';
import { TokenInterceptor } from './helpers/token.interceptor';
import { LayoutModule } from './layout/layout.module';
import { ModulesModule } from './modules/modules.module';
import { IndexComponent } from './index/index.component';

@NgModule({
  declarations: [AppComponent, IndexComponent],
  imports: [
    ModulesModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgbModule,
    BsDropdownModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    ToastrModule.forRoot(),
    CoreModule.forRoot(coreConfig),
    CoreCommonModule,
    CoreSidebarModule,
    CoreThemeCustomizerModule,
    LayoutModule,
    DirectivesModule,
    MatIconModule,
    MatDialogModule,
    QuillModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    CookieService,
  ],
  bootstrap: [IndexComponent],
})
export class AppModule { }
